import "./QASection.css";

import React, { useState, useEffect } from "react";
import Footer from "../../Footer";
import { useNavigate } from "react-router-dom";


const qaDataSelf = [
  {
    id: "step",
    header: "자비 출판의 이해"
  },
  {
    id: "q1",
    question: "자비 출판이란 무엇인가요?",
    answer: ` 자비 출판은 저자가 출간 비용을 부담하고, 출판사가 편집·디자인·제작부터 유통·정산 등 출간 이후 운영까지 지원하는 방식입니다. 도서 판매 수익은 계약에서 정한 기준에 따라 정산됩니다.`
  },
  {
    id: "q2",
    question: "자비 출판은 기획 출판·반기획 출판과 어떻게 다른가요?",
    answer: ` 자비 출판은 저자가 출간 비용을 부담한다는 점에서 기획 출판·반기획 출판과 차이가 있습니다.

              • 자비 출판 : 저자가 출간 비용을 부담하고, 출판사는 편집·디자인·제작·유통·정산 등 출간 과정을 지원합니다.
              • 반기획 출판 : 저자와 출판사가 출간 비용, 제작 역할, 유통·마케팅 범위 등을 협의해 분담합니다.
              • 기획 출판 : 출판사가 출간 비용과 판매 리스크를 부담하고, 기획부터 편집·제작·유통·마케팅까지 전 과정을 주도합니다.

              자비 출판은 저자가 출간 목적과 방향을 비교적 주도적으로 설정할 수 있고, 출판사는 이를 책으로 구현하고 유통·정산하는 과정을 지원합니다.`

  },
  {
    id: "q3",
    question: "자비 출판은 어떤 저자에게 적합한가요?",
    answer: ` 자비 출판은 출간 목적이 분명하고, 자신의 콘텐츠를 책으로 완성해 독자에게 전달하고 싶은 저자에게 적합합니다. 
              특히 개인의 경험이나 전문성을 정리하고 싶은 저자, 강의·컨설팅·브랜딩과 책을 연결하고 싶은 저자, 대중적인 시장성보다는 특정 독자층을 대상으로 책을 출간하고 싶은 저자에게 잘 맞습니다. 출판사의 기획 선정 여부와 관계없이 저자가 주도적으로 출간을 진행할 수 있다는 점도 자비 출판의 특징입니다.`
  },
  {
    id: "q4",
    question: "어떤 원고나 장르가 자비 출판에 적합한가요?",
    answer: `자비 출판은 저자의 개성, 경험, 전문성이 잘 드러나는 콘텐츠에 적합합니다.
             대표적인 장르로는 에세이, 소설, 시집, 자기계발서, 실용서, 전문 분야 실용서·가이드북 등이 있습니다. 
             대중 시장성이 크지 않더라도 명확한 주제와 독자층이 있다면 자비 출판이 좋은 선택이 될 수 있습니다.`
  },
  
  {
    id: "step",
    header: "출간 준비 및 검토"
  },
  {
    id: "q6",
    question: "자비 출판에 필요한 권장 원고 분량은 어느 정도인가요?",
    answer: `분야와 책의 성격에 따라 다르지만, 일반적으로 에세이나 소설은 A4 기준 약 80~100페이지 이상을 권장합니다. 
            실용서나 전문서는 주제의 깊이와 내용 구성에 따라 더 많은 분량이 필요할 수 있습니다. 다만 원고 분량은 글자 크기, 줄간격, 여백, 도표·이미지 포함 여부에 따라 달라질 수 있으므로, 정확한 출간 가능 여부는 원고 검토 후 안내드립니다.`
  },
  {
    id: "q7",
    question: "원고가 완성되지 않아도 상담할 수 있나요?",
    answer: `가능합니다. 다만 정확한 제작 범위와 비용, 출간 가능 여부를 안내드리기 위해서는 목차, 샘플 원고, 집필 계획, 출간 목적 등을 함께 준비해주시면 좋습니다. 원고가 아직 완성되지 않은 경우에는 원고 보완 방향이나 적합한 출간 방식부터 상담할 수 있습니다.`
  },
  {
    id: "q8",
    question: "자비 출판을 시작하기 전에 무엇을 준비하면 좋나요?",
    answer: `자비 출판을 시작하기 전에는 원고, 출간 목적, 독자층, 제작 방향을 미리 정리해두는 것이 좋습니다. 전체 목차와 원고 구성이 정리되어 있으면 상담과 제작 진행이 수월하며, 어떤 독자를 대상으로 어떤 메시지를 전할 책인지가 명확할수록 편집·디자인 방향을 잡기 쉽습니다.

            또한 판형, 제본 방식, 컬러 여부, 예산 범위, 유통 방식, 홍보 계획 등을 미리 생각해두면 제작 범위를 정하는 데 도움이 됩니다. 저자 소개, 책 소개, 주요 키워드, 추천 독자와 같은 도서 소개 자료도 온라인 서점 등록과 홍보에 필요합니다.`
  },
  {
    id: "q9",
    question: "바로 출간하기보다 준비가 더 필요한 경우도 있나요?",
    answer: ` 원고가 아직 충분히 정리되지 않았거나, 출간 목적이 불분명하거나, 비용과 일정에 대한 현실적인 계획이 부족한 경우에는 바로 출간을 권하지 않을 수 있습니다. 이 경우 원고 보완, 출간 방향 재정리, 전자책 중심 출간, 일정 조정 등을 제안드릴 수 있습니다.`
  },
  
  {
    id: "step",
    header: "비용 및 계약 조건"
  },
  {
    id: "q11",
    question: "자비 출판 진행 시 비용은 어떻게 정해지나요?",
    answer: `자비 출판 비용은 원고 분량, 편집 난이도, 판형, 디자인 범위, 종이책 제작 방식, 인쇄 부수, 마케팅 지원 여부 등에 따라 달라집니다. 
            정확한 비용은 원고 검토와 제작 사양 확정 후 안내드립니다.`
  },
  {
    id: "q12",
    question: "기본 서비스에는 무엇이 포함되나요?",
    answer: 
        `기본 서비스에는 전자책 출간에 필요한 기본 출간 지원이 포함됩니다. 
        ISBN 등록, 원고 검토 및 기본 편집, 기본 표지 디자인, 전자책 제작, 온라인 서점 유통 등록 지원, 판매 및 정산 관리 등이 포함될 수 있습니다. 
        종이책 제작, 전문 교정·교열, 맞춤형 표지 디자인, 상세페이지 제작, 마케팅 등은 계약 범위에 따라 추가 서비스로 진행할 수 있습니다.`
  },
  {
    id: "q13",
    question: "계약 전 확인해야 할 사항은 무엇인가요?",
    answer: 
        `계약 전에는 서비스 범위와 비용, 정산 기준, 유통 범위, 계약 기간을 명확히 확인하는 것이 중요합니다. 
        편집·디자인·제작 포함 범위, 추가 비용 발생 항목, 판매 수익 정산 기준, 출판권 및 유통 권한의 범위, 계약 기간과 해지 조건, 출간 후 관리 서비스 범위를 확인하는 것이 좋습니다.`
  },
  {
    id: "q14",
    question: "출간 후 관리비가 발생할 수 있나요?",
    answer: 
        `출간 후 유통·정산·도서 정보 관리 등을 위해 관리비가 발생할 수 있습니다. 관리비 여부와 금액, 제공 서비스 범위는 계약 조건에 따라 달라질 수 있습니다.`
  },
  {
    id: "q15",
    question: "비용은 어떻게 지불하나요?",
    answer: `일반적으로 자비 출판 비용은 계약금, 중도금, 잔금으로 나누어 지급합니다.
        계약금은 계약 체결 시, 중도금은 편집본 원고 확인 시, 잔금은 제작용 최종 원고 또는 최종 제작 파일 확인 후 출간·배포 전까지 지급합니다.
        구체적인 지급 일정과 금액은 계약서에서 정합니다.`
  },
  {
    id: "step",
    header: "편집·디자인 및 출간 과정"
  },
  {
    id: "q16",
    question: "편집은 어떻게 진행되나요?",
    answer:
        `편집은 원고의 상태와 계약 범위에 따라 단계별로 진행됩니다. 
        먼저 원고의 전체 구조와 흐름을 검토하고, 이후 문장 표현과 가독성을 다듬은 뒤, 출간 전 오탈자와 표기 통일 등을 최종 확인합니다.`
  },
  {
    id: "q17",
    question: "전문 편집이 꼭 필요한가요?",
    answer: `전문 편집이 반드시 필요한 것은 아니지만, 완성도 높은 책을 만들고 싶다면 권장됩니다. 
            전문 편집을 통해 원고의 구조와 흐름을 점검하고, 어색한 표현, 오탈자, 비문, 반복되는 문장을 정리할 수 있습니다.`
  },
  {
    id: "q18",
    question: "표지와 본문 디자인은 어떻게 진행되나요?",
    answer: `표지와 본문 디자인은 책의 콘셉트, 분위기, 타깃 독자 등을 바탕으로 방향을 정한 뒤 진행됩니다. 
            원고와 출간 목적에 맞춰 디자인 시안을 제작하고, 저자의 의견을 반영해 수정·보완한 후 최종 디자인을 확정합니다.`
  },
  {
    id: "q19",
    question: "편집·디자인 과정에서 저자의 역할은 무엇인가요?",
    answer: `저자는 목차와 원고 내용 확인, 편집자의 수정 제안 검토, 표지와 본문 디자인 시안 확인, 최종 교정지 검토, 책 소개와 저자 소개 등 홍보 자료에 필요한 정보 제공에 참여하게 됩니다.`
  },
  {
    id: "q20",
    question: "자비 출판은 전자책으로 출간되나요?",
    answer: `자비 출판은 전자책 출간을 기본으로 진행합니다. 
            전자책은 빠르게 제작할 수 있고 초기 제작 부담이 적어 온라인 유통에 적합합니다. 필요에 따라 종이책 제작도 추가로 선택할 수 있으며, 종이책 제작 여부는 출간 목적, 예산, 예상 독자층, 판매 방식 등을 고려해 상담 과정에서 함께 검토합니다.`
  },
  {
    id: "q21",
    question: "종이책 주문형 인쇄(POD)도 가능한가요?",
    answer: `필요에 따라 종이책 주문형 인쇄(POD)를 선택할 수 있습니다. POD는 초기 대량 인쇄 부담을 줄일 수 있는 방식으로, 판매량을 보면서 유연하게 운영하고 싶은 경우에 적합합니다.`
  },
  {
    id: "q22",
    question: "ISBN은 왜 필요한가요?",
    answer: `ISBN은 도서를 식별하기 위한 국제표준도서번호입니다. 온라인 서점 유통, 도서 정보 등록, 판매 관리 등을 위해 필요합니다. 전자책과 종이책은 각각 별도의 ISBN이 필요합니다.`
  },
  {
    id: "q23",
    question: "출간까지 전체 기간은 얼마나 걸리나요?",
    answer: `출간까지 걸리는 기간은 원고 분량, 편집 범위, 디자인 난이도, 전자책·종이책 제작 여부, 인쇄 방식 등에 따라 달라집니다. 일반적으로 편집 가능한 원고를 제출한 후 출간까지 약 2~3개월 정도 소요되며, 저자 피드백 속도나 제작 사양에 따라 일정은 달라질 수 있습니다. 정확한 일정은 원고 검토 후 제작 범위와 함께 안내드립니다.`
  },
  {
    id: "q24",
    question: "종이책 인쇄 부수는 어떻게 정하나요?",
    answer: `종이책 인쇄 부수는 예상 판매량, 저자의 예산 범위, 유통 계획, 보관 공간, 추가 인쇄 가능성 등을 고려해 정합니다. 
            초기 제작 부담을 줄이고 싶다면 주문형 인쇄(POD)를 선택할 수 있고, 일정 부수 이상 제작해 유통하려는 경우에는 일반 인쇄를 검토할 수 있습니다. 
            출간 목적과 예산에 맞춰 적정 인쇄 부수와 제작 방식을 함께 안내드립니다.`
  },      
  {
    id: "step",
    header: "유통·판매 및 정산"
  },
  {
    id: "q25",
    question: "자비 출판 도서는 어디에서 판매되나요?",
    answer: `계약 범위에 따라 주요 온라인 서점과 전자책 플랫폼에 등록해 판매할 수 있습니다. 
            대표적인 유통 채널로는 교보문고, YES24, 알라딘, 리디북스 등이 있으며, 도서의 형식과 제작 방식에 따라 중소형 서점 및 기타 판매 채널로도 유통을 검토할 수 있습니다. 다만 종이책과 전자책의 유통 가능 범위는 제작 방식, 유통 조건, 계약 내용에 따라 달라질 수 있습니다.`
  },
  {
    id: "q26",
    question: "오프라인 서점에도 진열될 수 있나요?",
    answer: `종이책으로 제작하는 경우 오프라인 서점 유통을 검토할 수 있습니다. 
            다만 실제 진열 여부는 유통 조건, 서점의 판단, 판매 흐름 등에 따라 달라질 수 있으며, 모든 서점 진열이 보장되는 것은 아닙니다.`
  },
  {
    id: "q27",
    question: "책의 정가는 어떻게 정해지나요?",
    answer: `책 정가는 제작비, 페이지 수, 판형, 컬러 여부, 경쟁 도서 가격, 예상 독자층, 유통 조건 등을 종합적으로 고려해 정합니다. 전자책과 종이책의 정가는 다르게 설정될 수 있으며, 최종 정가는 저자와 협의해 결정합니다.`
  },
  {
    id: "q28",
    question: "판매 수익은 어떻게 정산되나요?",
    answer: `자비 출판 도서의 판매 수익은 계약에서 정한 기준에 따라 정산됩니다. 
            종이책은 판매된 부수에 대해 정가의 50%, 전자책은 판매 순수익의 60%를 저자 인세로 지급합니다. 
            전자책 판매 순수익은 서점 및 전자책 유통사 수수료, 할인, 결제 수수료 등을 제외하고 출판사가 실제 정산받은 금액을 기준으로 합니다. 
            정산 주기와 지급 방식은 계약 조건에 따라 달라질 수 있습니다.`
  },
  {
    id: "q29",
    question: "판매 실적은 어떻게 확인하나요?",
    answer: `판매 실적은 정산 자료 또는 저자 포털을 통해 확인할 수 있습니다. 
            제공되는 정보의 범위와 업데이트 주기는 유통 채널과 계약 조건에 따라 달라질 수 있습니다.`
  },
  {
    id: "q30",
    question: "세금 신고는 어떻게 하나요?",
    answer: `도서 판매 수익이나 인세는 관련 세법에 따라 신고 대상이 될 수 있습니다. 
            출판사는 계약 조건에 따라 정산 자료나 지급 관련 서류를 제공할 수 있습니다. 
            구체적인 세금 처리는 개인의 소득 유형과 사업자 여부에 따라 달라질 수 있으므로, 필요한 경우 세무 전문가와 상담하는 것이 좋습니다.`
  },
  {
    id: "step",
    header: "마케팅 및 홍보"
  },
  {
    id: "q31",
    question: "마케팅 지원은 어떻게 진행되나요?",
    answer: `기본적인 도서 정보 등록과 출간 안내는 계약 범위에 따라 진행됩니다. 
            별도의 광고, 상세페이지 제작, SNS 캠페인, 북토크, 서평단 운영 등은 추가 마케팅 서비스로 진행할 수 있습니다.`
  },
  {
    id: "q32",
    question: "저자는 어떤 방식으로 마케팅에 참여할 수 있나요?",
    answer: `저자는 개인 SNS, 블로그, 뉴스레터, 강연, 커뮤니티, 지인 네트워크 등을 활용해 책을 홍보할 수 있습니다. 
            저자의 전문 분야나 활동 기반이 명확할수록 독자에게 책을 알리는 데 도움이 됩니다.`
  },
  {
    id: "q33",
    question: "서평이나 추천사 준비도 가능한가요?",
    answer: `가능합니다. 다만 서평이나 추천사는 도서의 주제, 저자의 네트워크, 전문가 섭외 가능성 등에 따라 달라질 수 있습니다. 
            필요한 경우 출간 일정에 맞춰 미리 준비하는 것이 좋습니다.`
  },
  {
    id: "q34",
    question: "판매 성과는 어느 정도 기대할 수 있나요?",
    answer: `자비 출판 도서가 단기간에 큰 판매 성과를 내는 경우는 많지 않습니다. 
            다만 명확한 독자층이 있거나, 저자의 전문성·활동 기반·홍보력이 뒷받침되는 경우 의미 있는 판매 성과를 기대할 수 있습니다.`
  },
  {
    id: "step",
    header: "사후 관리"
  },
  {
    id: "q35",
    question: "출간 후 어떤 관리 서비스를 받을 수 있나요?",
    answer: `출간 후에는 계약 범위에 따라 서점 유통 상태 관리, 판매 및 정산 자료 제공, 도서 정보 수정 지원, 독자 문의 접수 및 확인, 추가 인쇄 협의 지원 등을 받을 수 있습니다. 도서 판매, 정산, 유통 정보 관리 등 출간 이후 운영에 필요한 사항을 지원하며, 세부 제공 범위는 계약 조건에 따라 달라질 수 있습니다.`
  },
  {
    id: "q36",
    question: "종이책 재고는 어떻게 관리되나요?",
    answer: `종이책을 제작한 경우, 재고는 에이콘의 유통·물류 시스템을 통해 보관·관리합니다. 
            보관 방식, 배송 처리, 보관료 발생 여부 등은 인쇄 부수와 유통 조건에 따라 달라질 수 있으며, 세부 내용은 계약 시 안내드립니다.`
  },
  {
    id: "q37",
    question: "추가 인쇄는 언제 검토하나요?",
    answer: `재고가 부족하거나 추가 판매 가능성이 있다고 판단되는 경우, 저자와 협의해 추가 인쇄를 검토할 수 있습니다. 
            추가 인쇄 여부는 판매 추이, 남은 재고, 제작 비용, 유통 계획 등을 고려해 결정합니다.`
  },  
  {
    id: "step",
    header: "권리 및 계약 유의사항"
  },
  {
    id: "q38",
    question: "저작권은 누구에게 있나요?",
    answer: `원고의 저작권은 원칙적으로 저작자에게 있습니다. 
            출판사는 계약에서 정한 범위 안에서 도서를 제작·출간·유통할 수 있는 권한을 갖습니다. 
            출판권, 전자책 발행 및 유통 권한, 해외 출간, 오디오북 등 세부 권리 범위는 계약 조건에 따라 정합니다.`
  },
  {
    id: "q39",
    question: "계약을 중도 해지할 수 있나요?",
    answer: `계약 해지는 계약서에서 정한 조건에 따라 가능합니다. 
            일반적으로 양측 합의, 계약 위반, 진행 불가 사유 등이 있을 때 해지 절차를 진행할 수 있습니다. 
            해지 시 제작물 사용 범위, 이미 발생한 비용, 재고 처리, 유통 종료 시점 등을 함께 확인해야 합니다.`
  },
  {
    id: "q40",
    question: "AI를 활용해 작성한 원고도 출간할 수 있나요?",
    answer: `AI를 활용해 작성한 원고도 출간 검토가 가능합니다. 다만 AI 도구를 사용한 경우에는 사용 여부와 활용 범위를 사전에 알려주셔야 합니다. AI 생성 문장, 이미지, 도표, 번역문 등은 저작권·표절·사실 오류 문제가 발생할 수 있으므로 출간 전 확인이 필요하며, 최종 원고에 대한 책임은 저작자에게 있습니다.

            또한 기획, 원고 작성, 편집, 번역, 이미지 생성 과정에서 AI를 일부 또는 전부 활용한 경우, 온라인 서점 전자책 등록 시 ‘AI 생성·활용 도서’임을 표기해야 할 수 있습니다. 단순한 본문 교정·교열, 표지 디자인 보조 활용 등은 적용 범위가 달라질 수 있으므로, AI 활용 여부와 범위는 출간 전 반드시 확인해 주시기 바랍니다.`
  },
  {
    id: "q41",
    question: "표절이나 저작권 침해 문제가 발생하면 어떻게 되나요?",
    answer: `원고 내용의 저작권 침해, 표절, 명예훼손, 초상권 침해 등 법적 문제는 원칙적으로 저작자가 책임져야 합니다. 
            인용 자료, 이미지, 도표, 사진 등을 사용할 때는 출처와 사용 권한을 반드시 확인해야 합니다.`
  },
  {
    id: "q42",
    question: "계약 종료 후에는 어떻게 진행되나요?",
    answer: `계약 기간 만료 후에는 판매를 계속할지, 계약을 연장할지, 유통을 종료할지 협의합니다. 
            계약 종료 시 도서 파일, 재고, 유통 정보, 권리 관계 등은 계약서에서 정한 기준에 따라 처리합니다.`
  },
  {
    id: "step",
    header: "저자 포털 이용 안내"
  },
  {
    id: "q43",
    question: "저자 포털에서는 무엇을 확인할 수 있나요?",
    answer: `저자 포털에서는 계약 범위에 따라 출간 진행 상황, 유통 상태, 판매 및 정산 자료, 도서 정보 등을 확인할 수 있습니다. 
            제공 기능은 서비스 유형과 운영 범위에 따라 달라질 수 있습니다.`
  },
  {
    id: "q44",
    question: "저자 포털을 통해 정산 자료를 확인할 수 있나요?",
    answer: `저자 포털에서 판매 내역과 정산 정보를 확인할 수 있습니다. 
            자료 제공 시점과 세부 항목은 유통 채널의 정산 주기와 계약 조건에 따라 달라질 수 있으며, 필요한 경우 별도 정산 자료로 안내드릴 수 있습니다.`
  },
  {
    id: "q45",
    question: "포털 이용이 어려우면 어떻게 하나요?",
    answer: `포털 이용이 어려운 경우 이메일 문의를 통해 이용 방법을 안내받을 수 있습니다. 
            포털에서 제공되는 기능과 지원 범위는 계약 조건과 서비스 유형에 따라 달라질 수 있습니다.`
  },
  {
    id: "step",
    header: "상담 및 문의"
  },
  {
    id: "q46",
    question: "자비 출판 상담은 어떻게 신청하나요?",
    answer: `홈페이지 문의, 이메일, 전화 등을 통해 신청할 수 있습니다. 
            상담 시 원고의 개요, 출간 목적, 예상 독자층, 희망 출간 방식 등을 함께 알려주시면 보다 구체적인 안내가 가능합니다.`
  },
  {
    id: "q47",
    question: "상담 전에 어떤 자료를 준비하면 좋나요?",
    answer: `상담 전에는 원고 파일, 목차, 저자 소개, 책 소개, 출간 목적, 예상 독자층, 참고 도서, 희망 제작 방식 등을 준비하면 좋습니다. 
            원고가 완성되지 않았더라도 기획안이나 샘플 원고가 있다면 상담이 가능합니다.`
  },
  
];


const StepHeader = ({ header }) => (
  <div className="qa-step-header">
    <h4>{header}</h4>
  </div>
);

const QAItem = ({ id, question, answer, table, isOpen, onToggle }) => {
  const renderAnswer = () => {
    const answerContent = answer && (
      <p style={{ whiteSpace: "pre-line", marginBottom: table ? "1rem" : 0 }}>
        {answer}
      </p>
    );

    if (table) {      
      const lines = table.trim().split("\n");    
      const rows = lines
        .filter(line => line.trimStart().startsWith("|"))
        .map(line =>  
          line
            .trimStart()      
            .split("|")
            .slice(1, -1)
            .map(cell => cell.trim())
        );

      const [header, , ...body] = rows;

      return (
        <>
          {answerContent}
          <table className="qa-table">
            <thead>
              <tr>
                {header.map((cell, idx) => (
                  <th key={idx}>{cell}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {body.map((row, rIdx) => (
                <tr key={rIdx}>
                  {row.map((cell, cIdx) => (
                    <td key={cIdx}>{cell}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </>
      );
    } else {
      return answerContent;
    }
  };


  return (
    <div className={`qa-card ${isOpen ? "open" : ""}`}>
      <div
        className="qa-card-question-header"
        onClick={() => onToggle(id)}
        role="button"
        aria-expanded={isOpen}
        aria-controls={`qa-answer-${id}`}
        tabIndex="0"
      >
        <h3>{question}</h3>
        <img
          src="./images/arrow-down.png"
          alt="Toggle dropdown"
          className="qa-card-arrow"
        />
      </div>
      <div
        id={`qa-answer-${id}`}
        className="qa-card-answer"
        aria-hidden={!isOpen}
      >
        {renderAnswer()}
      </div>
    </div>
  );
};

const QASelf = () => {
  const navigate = useNavigate();
  const [openFAQId, setOpenFAQId] = useState(null);

  const handleToggleFAQ = (id) => {
    setOpenFAQId((prevId) => (prevId === id ? null : id));
  };
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <section className="qa-section-container">
        <div className="qa-section">
          <div className="qa-section-header">
            <button
              onClick={() => {
                navigate("/", { state: { scrollToFAQ: true } }); // 돌아갈 때 flag 전달
              }}
              className="carousel-nav-button prev"
              aria-label="Previous slide"
            >
              ❮
            </button>
            <h2>자비 출판 FAQ</h2>
          </div>
          <div className="qa-cards-container">
            {qaDataSelf.map((qa, index) => {
              if (qa.id === "step") {
                return <StepHeader key={`step-${index}`} header={qa.header} />;
              }
              return (
                <QAItem
                  key={qa.id}
                  id={qa.id}
                  question={qa.question}
                  answer={qa.answer}
                  table={qa.table}
                  isOpen={openFAQId === qa.id}
                  onToggle={handleToggleFAQ}
                />
              );
            })}
          </div>          
        </div>      
      </section>
      <Footer />
    </div>
  );
};

export default QASelf;
